import {
  CHANGE_LANGUAGE_REQUEST,
  CHANGE_LANGUAGE_SUCCESS,
  CHANGE_LANGUAGE_FAILURE
} from '../actions/languageActions';

const initialState = {
  loading: false,
  error: null,
  success: false
};

const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_LANGUAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    
    case CHANGE_LANGUAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true
      };
    
    case CHANGE_LANGUAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };
    
    default:
      return state;
  }
};

export default languageReducer;
